export default function Schema({
  metaDescription,
}: {
  metaDescription: string;
}) {
  const internalMetaDescription = JSON.stringify(metaDescription);
  const schema = `{
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://www.seniorly.com",
    "name": "Seniorly",
    "inLanguage": "en-US",
    "description": ${internalMetaDescription},
    "sameAs": "https://www.linkedin.com/company/seniorly/mycompany/",
    "author": {
      "@type": "Organization",
      "name": "Seniorly Inc."
    },
    "audience": {
      "@type": "Audience",
      "name": "Caregivers, Senior Care, Senior Housing, Senior Living, Assisted Living, Placement Agents, Elder care, Aging"
    },
    "contentLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "San Francisco",
        "addressRegion": "CA"
      }
    },
    "publisher": {
      "@type": "Organization",
      "@id": "https://www.seniorly.com/#organization",
      "name": "Seniorly",
      "url": "https://www.seniorly.com",
      "sameAs": [
        "https://www.linkedin.com/company/seniorly/mycompany/",
        "https://www.facebook.com/seniorly",
        "https://twitter.com/seniorly",
        "https://www.instagram.com/seniorly/",
        "https://www.pinterest.com/seniorly/",
        "https://www.youtube.com/@Seniorly"
      ],
      "logo": {
        "@type": "ImageObject",
        "@id": "https://www.seniorly.com/#logo",
        "url": "https://www.seniorly.com",
        "width": 40,
        "height": 40,
        "caption": "Seniorly"
      },
      "image": {
        "@type": "ImageObject",
        "@id": "https://www.seniorly.com/#logo",
        "url": "https://d354o3y6yz93dt.cloudfront.net/images/1200x/ba8c5f1e48b0de1d0b60639d1f4d3fe9/seniorly-logo-white.png",
        "width": 40,
        "height": 40,
        "caption": "Seniorly"
      }
    }
  }`;

  return schema;
}
